import { render, staticRenderFns } from "./Autenticar.vue?vue&type=template&id=556c1b28&scoped=true&"
import script from "./Autenticar.vue?vue&type=script&lang=js&"
export * from "./Autenticar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556c1b28",
  null
  
)

export default component.exports